import * as React from "react";
const SvgShortcutsFill = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M17 2a1 1 0 0 1 .82 1.573L14.028 9H19c.92 0 1.334 1.122.69 1.724l-.085.073-14.5 11c-.86.652-2.001-.333-1.481-1.279L7.758 13H4.5a1 1 0 0 1-.872-1.49l.062-.095 6.5-9A1 1 0 0 1 11 2z", clipRule: "evenodd" }));
export default SvgShortcutsFill;
